var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftHand = function SvgLeftHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M11.023 13.628 2.178 6.71 1 1l5.71 1.179 6.917 8.844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M11.815 19.013 8.56 17.289a21 21 0 0 1 8.73-8.73l1.723 3.255a17.3 17.3 0 0 0-7.199 7.198"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M16.244 13.64 21 18.396 18.396 21l-4.756-4.756"
  })));
};
export default SvgLeftHand;